import Vue from "vue";

export const teamsService = {
  list,
  getById,
  create,
  update
};

function list(realEstateId, params) {
  return Vue.axios.get(`v2/manager/state_agencies/${realEstateId}/teams`, {
    params
  });
}

function getById(payload) {
  return Vue.axios.get(
    `v2/manager/state_agencies/${payload.realEstateId}/teams/${payload.id}`
  );
}

function create(realEstateId, payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("team_manager_id", payload.managerId);

  return Vue.axios.post(
    `v2/manager/state_agencies/${realEstateId}/teams`,
    formData
  );
}

function update(realEstateId, payload) {
  const formData = new FormData();

  if (payload.name != null && payload.managerId != null) {
    formData.set("name", payload.name);
    formData.set("team_manager_id", payload.managerId);
  }

  if (payload.building_ids != null) {
    if (payload.building_ids.length) {
      payload.building_ids.forEach(building_id => {
        formData.append("building_ids[]", building_id);
      });
    } else {
      formData.set("building_ids[]", []);
    }
  }

  if (payload.realtor_ids.length) {
    payload.realtor_ids.forEach(realtor_id => {
      formData.append("realtor_ids[]", realtor_id);
    });
  } else {
    formData.set("realtor_ids[]", []);
  }

  return Vue.axios.patch(
    `v2/manager/state_agencies/${realEstateId}/teams/${payload.id}`,
    formData
  );
}
